import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { Button } from '../ui/Button';
export function OfferSection() {
  const deliverables = [{
    title: 'Guía Maestra Digital',
    desc: 'El paso a paso completo del método brasileño original.'
  }, {
    title: 'Protocolo de Activación',
    desc: 'Cómo abrir tus ganglios en 3 minutos para que el drenaje funcione.'
  }, {
    title: 'Las 5 Maniobras Maestras',
    desc: 'Ilustraciones claras de dónde poner las manos y qué presión ejercer.'
  }, {
    title: "Rutina de 'Oro' de 15 Minutos",
    desc: 'El esquema diario para mantener los resultados.'
  }, {
    title: 'Lista de Aceites Drenantes',
    desc: 'Qué usar sobre la piel para maximizar la eliminación de toxinas.'
  }, {
    title: 'Planificador de 21 Días',
    desc: 'Para crear el hábito y ver la transformación real en el espejo.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-124">
      <div className="max-w-4xl mx-auto" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-126">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-[#3D2B1F] mb-4" data-id="element-127">
            Todo lo que recibes hoy
          </h2>
          <div className="w-24 h-1 bg-[#C8956C] mx-auto rounded-full" data-id="element-128" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-129">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#FDF8F0] p-6 rounded-xl border border-[#C8956C]/20 hover:border-[#C8956C] transition-colors" data-id="element-130">
              <div className="flex items-start gap-4" data-id="element-131">
                <CheckCircle2Icon className="w-6 h-6 text-[#7C9A6E] shrink-0 mt-1" data-id="element-132" />
                <div data-id="element-133">
                  <h3 className="font-bold text-[#3D2B1F] text-lg mb-1" data-id="element-134">
                    {item.title}
                  </h3>
                  <p className="text-[#5A4332]" data-id="element-135">{item.desc}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-136">
          <Button data-id="element-137">¡QUIERO MI GUÍA AHORA!</Button>
        </motion.div>
      </div>
    </section>;
}